import { Mail, MessageSquare, MapPin, Calendar, ArrowUpRight, Twitter, Linkedin, Github, Instagram } from "lucide-react";
import { Container, FadeUp } from "./primitives";

const CHANNELS = [
  {
    icon: Mail,
    k: "Sales email",
    v: "support@sosmedlead.my.id",
    href: "mailto:support@sosmedlead.my.id",
    testId: "contact-email",
  },
  {
    icon: MessageSquare,
    k: "WhatsApp",
    v: "Chat with a human",
    href: "https://wa.me/6281233829393",
    testId: "contact-whatsapp",
  },
  {
    icon: Calendar,
    k: "Schedule demo",
    v: "Book 20 minutes",
    href: "#",
    testId: "contact-demo",
  },
  {
    icon: MessageSquare,
    k: "Live chat",
    v: "Weekdays 09:00 – 22:00 WIB",
    href: "#",
    testId: "contact-livechat",
  },
];

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="relative py-32 md:py-40 border-t border-white/10 overflow-hidden">
      <div className="orb bg-[#4F46E5] w-[560px] h-[560px] -bottom-40 left-[10%] opacity-20" />
      <Container className="relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <FadeUp className="lg:col-span-6">
            <div className="font-mono-x text-xs tracking-[0.24em] uppercase text-white/40">Chapter 11 · Contact</div>
            <h2 className="mt-4 font-display text-[clamp(2.25rem,5vw,4.75rem)] tracking-[-0.03em] leading-[0.98]">
              Let’s make your next quarter{" "}
              <span className="font-serif-x italic">obvious.</span>
            </h2>
            <p className="mt-6 max-w-lg text-white/60 leading-relaxed text-[15px]">
              Book a 20-minute walkthrough, or reach out any way you like. We reply within a business day — usually much faster.
            </p>

            <div className="mt-10 flex items-start gap-3 text-white/60 text-sm">
              <MapPin className="h-4 w-4 mt-0.5 shrink-0 text-white/50" />
              <div>
                <div className="text-white">SocialLead HQ</div>
                <div>Jakarta · Singapore · San Francisco</div>
              </div>
            </div>

            <div className="mt-8 flex items-center gap-2">
              {[Twitter, Linkedin, Github, Instagram].map((Ic, i) => (
                <a key={i} href="#" data-testid={`social-${i}`} className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/[0.03] hover:bg-white/[0.06] transition-colors">
                  <Ic className="h-4 w-4 text-white/80" strokeWidth={1.5} />
                </a>
              ))}
            </div>
          </FadeUp>

          <div className="lg:col-span-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {CHANNELS.map((c, i) => (
              <FadeUp key={c.k} delay={i * 0.05}>
                <a
                  data-testid={c.testId}
                  href={c.href}
                  className="group relative flex flex-col justify-between rounded-2xl border border-white/10 bg-white/[0.02] p-6 h-full min-h-[180px] hover:border-white/25 hover:bg-white/[0.05] transition-colors"
                >
                  <div className="flex items-center justify-between">
                    <span className="flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 bg-white/[0.03]">
                      <c.icon className="h-4 w-4 text-white/80" strokeWidth={1.5} />
                    </span>
                    <ArrowUpRight className="h-4 w-4 text-white/50 group-hover:text-white group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
                  </div>
                  <div className="mt-8">
                    <div className="text-[10px] font-mono-x uppercase tracking-[0.22em] text-white/40">{c.k}</div>
                    <div className="mt-1 font-display text-lg tracking-[-0.02em]">{c.v}</div>
                  </div>
                </a>
              </FadeUp>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}
